import React from 'react';

import { check, upgrade } from '@/assets/icons';
import { AsaphButton } from '@/components/shared/Button';
import { Chip } from '@/components/shared/Chip/Chip';
import { classNames } from '@/helpers/classNames';
import { SvgIcon } from '@material-ui/core';

import styles from './PricingCard.module.scss';

export interface PricingCardProps {
	title: string;
	description: string;
	pricePrefix?: string;
	priceAmount: string;
	priceSuffix: string;
	priceNote?: string;
	buttonLabel: string;
	buttonColor?: 'blue' | 'green' | 'grey' | 'inactive' | 'white' | 'gradient';
	includes: string;
	baseIncludes?: string;
	features: string[];
	onClick?: () => void;
	current?: boolean;
	disabled?: boolean;
	noIcon?: boolean;
	comingSoon?: boolean;
	buttonClassName?: string;
}

export const PricingCard: React.FC<PricingCardProps> = ({
	title,
	description,
	pricePrefix,
	priceAmount,
	priceSuffix,
	priceNote,
	buttonLabel,
	buttonColor = 'blue',
	includes,
	baseIncludes,
	features,
	onClick,
	current = false,
	disabled = false,
	noIcon = false,
	comingSoon = false,
	buttonClassName,
}) => (
	<div className={[styles['pricing-card'], current ? styles['pricing-card--current'] : ''].join(' ')}>
		<div className={styles['pricing-card__title']}>
		{title}
		{comingSoon && (
			<Chip color="light-blue" variant="rounded" className={styles['pricing-card__coming-soon-chip']}>
				Coming Soon
			</Chip>
		)}
	</div>
		<div className={styles['pricing-card__description']}>{description}</div>
		<div className="vsb-15" />
		<div className={styles['pricing-card__price']}>
			{pricePrefix && (
				<span className={styles['pricing-card__price-prefix']}>
					{pricePrefix}&nbsp;
				</span>
			)}
			<span className={styles['pricing-card__price-amount']}>
				{priceAmount}
			</span>
			<span className={styles['pricing-card__price-suffix']}>
				{' '}{priceSuffix}
			</span>
		</div>
		{priceNote && (
			<div className={styles['pricing-card__price-note']}>{priceNote}</div>
		)}
		<div className="vsb-15" />
		<AsaphButton
			color={buttonColor}
			label={buttonLabel}
			icon={
				!noIcon && !disabled ? (
					<SvgIcon component={upgrade} color="inherit" />
				) : undefined
			}
			className={classNames([
				styles['pricing-card__button'],
				buttonClassName,
			])}
			onClick={onClick}
			disabled={disabled}
		/>
		<div className="vsb-20" />
		<div className={styles['pricing-card__includes']}>
			Includes <strong>{includes}</strong>
		</div>
		{baseIncludes && (
			<>
				<div className="vsb-10" />
				<div className={styles['pricing-card__base-includes']}>
					{baseIncludes}
				</div>
			</>
		)}
		<div className="vsb-8" />
		<ul className={styles['pricing-card__features']}>
			{features.map((f, i) => (
				<li key={i}>
					<SvgIcon component={check} className={styles['pricing-card__feature-icon']} />
					{f}
				</li>
			))}
		</ul>
	</div>
);
